<template>
  <el-col :span="span" :xs="xs" :sm="sm" :md="md" :lg="lg" :xl="xl" :offset="offset" :push="push" :pull="pull" style="vertical-align: top;text-align: left;padding: 12px 0;"><slot></slot></el-col>
</template>

<script>
    export default {
        name: "index",
        props: {
            xs: '',
            sm: '',
            md: '',
            lg: 6,
            xl: 6,
            span: {
                default: 8
            },
            offset: {
                type: Number,
                default: 0
            },
            push: {
                type: Number,
                default: 0
            },
            pull: {
                type: Number,
                default: 0
            }
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// UI/Col/index.vue